/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeUnexpectedPaymentOutcome204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeUnexpectedPaymentOutcome505Schema = z.any();

export const optionsChangeUnexpectedPaymentOutcomeMutationResponseSchema = z.lazy(
  () => optionsChangeUnexpectedPaymentOutcome204Schema
);
